import React from 'react';

import { useDashboardData } from '../../hooks/useDashboardData';
import { useDocumentTitle } from '../../hooks';
import { QueryResult } from '../molecules';
import { Dashboard, Page } from '../organisms';

export const DashboardPage: React.FC = () => {
  const dashboardData = useDashboardData();

  // Update browser tab title
  useDocumentTitle('Features Dashboard');

  return (
    <Page title={null} fullWidth>
      <QueryResult query={dashboardData} renderAs={(data) => <Dashboard data={data} />} />
    </Page>
  );
};
